import { render, staticRenderFns } from "./paybright.vue?vue&type=template&id=554e4c62&"
import script from "./paybright.vue?vue&type=script&lang=js&"
export * from "./paybright.vue?vue&type=script&lang=js&"
import style0 from "./paybright.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports